import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

@Injectable({ providedIn: 'root' })
export class FetchAuthenticatedUserApiQuery extends ApiQuery<UserOutput, void> {
	client = 'iam';
	document = gql`
		query FetchAuthenticatedUser {
			fetchAuthenticatedUser {
				...User
			}
		}
		${user}
	`;
	method = 'fetchAuthenticatedUser';
}
